import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './cross-sell-item.component.scss';
var CrossSellItem = /** @class */ (function (_super) {
    tslib_1.__extends(CrossSellItem, _super);
    function CrossSellItem(element) {
        return _super.call(this, element) || this;
    }
    CrossSellItem.prototype.init = function () { };
    ;
    CrossSellItem.prototype.bindEvents = function () { };
    ;
    return CrossSellItem;
}(Base));
export { CrossSellItem };



//////////////////
// WEBPACK FOOTER
// ./components/cross-sell-item/cross-sell-item.component.ts
// module id = 241
// module chunks = 0